// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

// Vuetify
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

const theme = {
  defaultTheme: 'light',
  themes: {
    light: {
      colors: {
        primary: '#EE730F',
        secondary: '#19273D',
        accent: '#9C27b0',
        info: '#00CAE3'
      }
    }
  }
};

export default createVuetify({
  components,
  directives,
  theme,
  icons: {
    defaultSet: 'mdi'
  }
});
